import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { OnlyContinueButton } from 'components/base/BottomStepComponent';
import { CampaignType, showCampaignPublishChannelSelector } from 'config/CustomEnums';
import { validate } from 'containers/engagement/campaign/CreateCampaignValidate';
import { CREATION_STEP_ONE_CONFIG } from 'containers/engagement/campaign/CampaignCreationConfig';

import './CreateCampaignStepOne.scss';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';

const mapPropsToState = (state) => ({
  status: state.createCampaign.createStatus,
  isPublished: state.createCampaign.campaign.isPublished,
});
function CreateCampaignStepOneV2() {
  const dispatch = useDispatch();
  const {
    getValues,
    watch,
    setValue,
    formState: { errors },
    clearErrors,
    setError,
  } = useFormContext();
  const {
    extraValidate,
  } = CREATION_STEP_ONE_CONFIG

  const earningRuleField = 'linkedEarningRules';
  const couponField = 'linkedCoupon';

  const watchCampaignType = watch('campaignType');
  const watchCoupon = watch(couponField) || {};
  const watchEarningRules = watch(earningRuleField);
  const watchPublishChannel = watch('publishChannel');

  const goToNextStep = (assignRemain) => {
    let isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 0,
      isBack: false,
    });
    if (extraValidate) {
      isValid = extraValidate({
        getValues,
        setError,
        clearErrors
      }) && isValid
    }
    console.log('isValid:', isValid, errors);
    setValue('assignRemain', assignRemain);
    dispatch({
      type: 'createCampaign/stepChange',
      payload: {
        step: 0,
        isValid,
      },
    });
  };

  const disabledContinueButton = useMemo(() => {
    if (!watchCampaignType) {
      return true
    }
    if (![
      CampaignType.couponsCampaign, 
      CampaignType.earningRulesCampaign,
      CampaignType.ticketCampaign,
    ].includes(watchCampaignType)
    ) {
      return false
    }
    if (showCampaignPublishChannelSelector && !watchPublishChannel?.length > 0) {
      return true
    }
    if (watchCampaignType === CampaignType.couponsCampaign) {
      return !watchCoupon?.pk
    }
    if (watchCampaignType === CampaignType.earningRulesCampaign) {
      return !watchEarningRules?.pk
    }
    return false
  }, [watchCampaignType, watchPublishChannel, watchCoupon, watchEarningRules])

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_ONE_CONFIG}
        hidePreview={true}
      />
      <OnlyContinueButton
        continueAction={async () => {
          goToNextStep(true);
        }}
        disabledContinue={disabledContinueButton}
      />
    </>
  );
}

export default connect(mapPropsToState)(CreateCampaignStepOneV2);
